import { render, staticRenderFns } from "./prehistorylist.vue?vue&type=template&id=13a5119c&scoped=true"
import script from "./prehistorylist.vue?vue&type=script&lang=js"
export * from "./prehistorylist.vue?vue&type=script&lang=js"
import style0 from "./prehistorylist.vue?vue&type=style&index=0&id=13a5119c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a5119c",
  null
  
)

export default component.exports